// extracted by mini-css-extract-plugin
export var backupIcon = "_nz-1";
export var image = "_nz-0";